module.exports = __webpack_public_path__ + "img/GS_Profile-Thabang Mathekga.14ecbd94.png";